module.exports = __webpack_public_path__ + "img/alentour16.dbff6307.jpg";